import { IPortalShellEventHandlers } from '../../models/globalScript';
import Logger from '../logger/logger';

export class EventHandlersInstanceResolver {
    private static _eventHandlersInstance: IPortalShellEventHandlers;

    public static Instantiate(eventHandlersInstance: IPortalShellEventHandlers) {
        Logger.debug('EventHandlersInstanceResolver', 'Instantiate', { object: eventHandlersInstance });
        window.PortalShell.EventHandlers = eventHandlersInstance;
        this._eventHandlersInstance = window.PortalShell.EventHandlers;

        return this._eventHandlersInstance;
    }

    public static get Instance() {
        return this._eventHandlersInstance;
    }
}
